"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_query_1 = require("react-query");
const react_router_dom_1 = require("react-router-dom");
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const adminClient_1 = require("client/adminClient");
const ToastContext_1 = require("context/ToastContext");
const UserContext_1 = require("context/UserContext");
const useFilter_1 = __importDefault(require("hooks/useFilter"));
const useLocale_1 = require("hooks/useLocale");
const HelperUtils_1 = require("utils/HelperUtils");
const AdvancedFilter_1 = __importDefault(require("components/advance-filter/AdvancedFilter"));
const Button_1 = __importDefault(require("components/design-system/Button"));
const Dropdown_1 = __importStar(require("components/design-system/dropdown/Dropdown"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const CardBoxSurvey_1 = __importDefault(require("./CardBoxSurvey"));
const EmptyStateResult_1 = __importDefault(require("./EmptyStateResult"));
const SurveyResultHelper_1 = require("./SurveyResultHelper");
const SurveyResult = ({ title, isPast }) => {
    const domRef = (0, react_1.useRef)(null);
    const params = (0, react_router_dom_1.useParams)();
    const searchParams = new URLSearchParams(location.search);
    const occurrenceId = searchParams.get('occurrenceId') || '';
    const { config } = (0, UserContext_1.useUser)();
    const { setBothLocale } = (0, useLocale_1.useLocale)();
    const { addToast } = (0, ToastContext_1.useToastContext)();
    const filterById = (0, useFilter_1.default)((state) => state?.filterById) || {};
    const filter = filterById?.surveyResult;
    const isThereFilter = config.generalFilterOptions?.find((listFilter) => !(0, isEmpty_1.default)(filter?.[listFilter])) !== undefined;
    const [isDownloadJpeg, setIsDownloadJpeg] = (0, react_1.useState)(false);
    const [isFirstRender, setIsFirstRender] = (0, react_1.useState)(true);
    const getData = async () => {
        const { data } = await (0, adminClient_1.getBreakdownSurveyResult)(params?.id, {
            ...filter,
            surveyOccurrenceId: parseInt(occurrenceId)
        });
        return data;
    };
    const { data: surveyData, refetch } = (0, react_query_1.useQuery)(['surveyResult'], () => getData());
    const isDataEmpty = surveyData?.totalVoterCount === 0;
    const isShowFilter = isFirstRender ? !isDataEmpty : true;
    const _getListFilter = (addedParams) => {
        const fetchFilter = () => {
            return (0, adminClient_1.getListFilter)(addedParams);
        };
        const { data, status, fetchNextPage, isFetchingNextPage } = (0, react_query_1.useInfiniteQuery)(['filter', addedParams], () => fetchFilter(), {
            getNextPageParam: (lastPage) => lastPage.pagination?.next || 0
        });
        return { data, status, isFetchingNextPage, fetchNextPage };
    };
    const getFilterData = async (addedParams) => {
        return await (0, adminClient_1.getListFilter)({
            q: addedParams?.q,
            key: addedParams?.key,
            ...addedParams
        });
    };
    const downloadImage = async ({ dom, type }) => {
        addToast({
            title: 'Downloading',
            type: 'info'
        });
        type === 'jpeg' ? setIsDownloadJpeg(true) : setIsDownloadJpeg(false);
        const { isSuccess } = await (0, SurveyResultHelper_1.downloadImg)({ dom, title, type });
        if (isSuccess) {
            addToast({
                title: 'Success',
                msg: setBothLocale('Your file has been successfully downloaded'),
                type: 'success'
            });
        }
        else {
            addToast({
                title: 'Failed',
                msg: setBothLocale('Failed to download your survey'),
                type: 'error'
            });
        }
    };
    const options = [
        {
            key: 'JPG',
            text: 'JPG',
            onClick: () => domRef.current && downloadImage({ dom: domRef.current, type: 'jpeg' })
        },
        {
            key: 'PNG',
            text: 'PNG',
            onClick: () => domRef.current && downloadImage({ dom: domRef.current, type: 'png' })
        }
    ];
    (0, react_1.useEffect)(() => {
        refetch();
        if (isThereFilter) {
            setIsFirstRender(false);
        }
    }, [filter, isThereFilter, refetch]);
    return (react_1.default.createElement("div", { className: "w-full flex flex-col items-center" },
        isShowFilter && (react_1.default.createElement("div", { className: "flex justify-between items-center mt-[24px] w-[1040px]" },
            react_1.default.createElement(AdvancedFilter_1.default, { id: "surveyResult", filterOptions: ['menuFilter'], filterMenu: config.generalFilterOptions, filterClient: getFilterData, addedQueryParams: { surveyId: params.id }, dialogQueryFn: (params) => _getListFilter(params) }))),
        !isDataEmpty && (react_1.default.createElement("div", { className: `p-[24px] grid gap-y-[24px] rounded-[8px] fade-in ${isDownloadJpeg ? 'bg-n-000' : ''}`, ref: domRef }, surveyData?.questions.map((question) => {
            return (react_1.default.createElement("div", { className: "flex justify-center", key: question.id },
                react_1.default.createElement(CardBoxSurvey_1.default, { orderLevel: question.orderLevel, pollOptions: question.pollOptions, voterCount: question.voterCount, question: question.question, type: question.type, occurrenceId: occurrenceId, surveyId: params.id, essayId: question.id })));
        }))),
        isDataEmpty && (react_1.default.createElement(EmptyStateResult_1.default, { isThereFilter: isThereFilter, isPast: isPast, surveyId: params.id, occurrenceId: occurrenceId }))));
};
const DropdownTrigger = () => {
    const { open } = (0, Dropdown_1.useDropdown)();
    return (react_1.default.createElement(Dropdown_1.default.Trigger, { dataCy: "dropdown-survey-result" },
        react_1.default.createElement(Button_1.default, { stopPropagation: false, variant: "secondary", customClass: open ? 'border-base-500 bg-base-30024' : '' },
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(SVGIcon_1.default, { iconName: "icon-file_download", size: 24, fillColor: open ? 'var(--base-500)' : 'var(--n-600)', customClass: "mr-[8px]" }),
                react_1.default.createElement("p", { className: "typography-button" }, (0, HelperUtils_1.getCultureLocale)('Download'))))));
};
exports.default = SurveyResult;
